export default function ({ app }) {
    // check if a token has been saved for the user
    const hasToken = !!app.$apolloHelpers.getToken();
    if (hasToken) {
        const token = `Bearer ${app.$apolloHelpers.getToken()}`;
        app.$axios.setToken(token);
    }
}
